import { useState } from "react";
import css from "../../styles/PromotionSeal.module.css";

const PromotionSeal = ({ discountSeal, styles = {} }) => {
  const [isValid, setIsValid] = useState(false);

  if (discountSeal) {
    return (
      <div className={css.promotionSeal} style={{ ...styles }}>
        <img
          src={discountSeal}
          alt="Promotion Seal"
          onError={() => setIsValid(false)}
          onLoad={() => setIsValid(true)}
          style={{ display: isValid ? "block" : "none" }}
        />
      </div>
    );
  }

  return null;
};

export default PromotionSeal;
